import { HttpErrorResponse } from "@angular/common/http"
import { createAction, props } from "@ngrx/store"
import { StarResponse } from "src/app/models/stars/stars.models"

export const storeStars = createAction(
    '[Stars] Store stars',
    props<{ action: string }>()
)

export const storeStarsSuccess = createAction(
    '[Stars] Store stars success',
    props<{ starsResponse: StarResponse }>()
)

export const storeStarsFailure = createAction(
    '[Stars] Store stars failure',
    props<{ error: HttpErrorResponse }>()
)